<template>
  <v-card>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text">
        Registra Elementi.
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <!-- Bottone di salvataggio -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="chkRegistrazioneElementi" small v-bind="attrs" v-on="on">
            <v-icon color="success"> mdi-floppy </v-icon>
          </v-btn>
        </template>
        <span>Salva</span>
      </v-tooltip>

      <v-spacer></v-spacer>

      <!-- Bottone di chiusura -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="clickChiudi" small v-bind="attrs" v-on="on">
            <v-icon color="error"> mdi-close </v-icon>
          </v-btn>
        </template>
        <span>Chiudi</span>
      </v-tooltip>
    </v-toolbar>

    <v-card-text>
      <v-container fluid>
        <v-row align="center" dense justify="center">
          <v-col cols="12">
            <v-data-table :headers="headers_elementi" :items="items_elementi">
              <template v-slot:[`item.selezionato`]="{ item }">
                <v-simple-checkbox
                  color="primary"
                  v-model="item.selezionato"
                ></v-simple-checkbox>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <!-- Dialog di conferma eliminazione dei partner -->
    <v-dialog v-model="dialog_conferma_salvataggio" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Salvataggio </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="color: rgb(0, 0, 0); font-size: 18px">
            Non hai dichiarato nessun elemento e risulterà che non hai lavorato
            su nessun eelmento durante il tuo turno di lavoro. Sei veramente
            sicuro di voler procedere?
          </span>
          <v-divider class="my-5"></v-divider>
          <v-container fluid>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-btn class="mr-5" @click="registrazioneElementi" small>
                  <v-icon color="success"> mdi-check </v-icon>
                </v-btn>

                <v-btn @click="dialog_conferma_salvataggio = false" small>
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Overlay di caricamento -->
    <v-overlay :value="overlay" style="z-index: 10">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import moment from "moment";

export default {
  name: "RegistraElementi",
  components: { SnackbarQV },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    work_order_sel: { type: Object, default: () => {} },
  },
  data() {
    return {
      // Variabili d'appoggio

      // Modal
      dialog_conferma_salvataggio: false,
      overlay: false,

      // Array
      headers_elementi: [
        {
          value: "selezionato",
          text: "Selezione",
          sortable: false,
          width: "100px",
        },
        {
          value: "num_elemento_display",
          text: "Num. Elemento",
          sortable: false,
          width: "200px",
        },
        {
          value: "des_elemento",
          text: "Elemento",
          sortable: false,
        },
        {
          value: "persona",
          text: "Persona",
          sortable: false,
        },
        {
          value: "rif_commessa",
          text: "Rif. Commessa",
          sortable: false,
        },
        /*{
          value: "cod_commessa",
          text: "Commessa",
          sortable: false,
        },
        {
          value: "cod_fase",
          text: "Fase",
          sortable: false,
        },*/
        {
          value: "cod_articolo",
          text: "Cod. Articolo",
          sortable: false,
        },
        /*{
          value: "des_articolo",
          text: "Des. Articolo",
          sortable: false,
        },*/
      ],
      items_elementi: new Array(),
    };
  },
  computed: {},
  watch: {
    visible: {
      immediate: true,
      handler() {
        if (this.visible) {
          this.getCommessaElementi();
        }
      },
    },
  },
  methods: {
    chkRegistrazioneElementi() {
      if (
        this.items_elementi.filter((e) => e.selezionato == true).length == 0
      ) {
        this.dialog_conferma_salvataggio = true;
      } else {
        this.registrazioneElementi();
      }
    },
    clickChiudi() {
      this.$emit("click_indietro");
    },
    getCommessaElementi() {
      // Controllo di avere elementi.
      if (
        !this.work_order_sel.dati_commessa_elementi ||
        this.work_order_sel.dati_commessa_elementi.indexOf("|") == -1
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Non ci sono elementi da visualizzare."
        );
        return;
      }

      this.items_elementi = new Array();

      // Se ho elementi, li compongo e li visualizzo.
      try {
        const stringhe_elementi =
          this.work_order_sel.dati_commessa_elementi.split(";");

        stringhe_elementi.forEach((substring) => {
          const array_proprieta = substring.split("|");

          const obj_tmp = {
            id_commessa_movimenti: -1,
            quantita: 1,
            id_personale: localStorage.id,
            data: moment().format("YYYY-MM-DD HH:mm:ss"),
            id_causale: -97,
            id_macchina: this.work_order_sel.id_macchina,
            id_commessa: array_proprieta[0] ? array_proprieta[0] : null,
            cod_commessa: array_proprieta[2] ? array_proprieta[2] : null,
            rif_commessa: array_proprieta[3] ? array_proprieta[3] : null,
            cod_fase: array_proprieta[4] ? array_proprieta[4] : null,
            cod_articolo: array_proprieta[5] ? array_proprieta[5] : null,
            des_articolo: array_proprieta[6] ? array_proprieta[6] : null,
            id_commessa_dettaglio: array_proprieta[1]
              ? array_proprieta[1]
              : null,
            id_commessa_tempi: this.work_order_sel.id_commessa_tempi,
            id_lotto_seriale: array_proprieta[7] ? array_proprieta[7] : null,
            num_elemento_display: `E${
              array_proprieta[7] ? array_proprieta[7] : ""
            }`,
            des_elemento: array_proprieta[8] ? array_proprieta[8] : null,
            personale: array_proprieta[9] ? array_proprieta[9] : null,
          };
          this.items_elementi.push(obj_tmp);
        });
      } catch (err) {
        this.overlay = false;
        console.error(err);
        this.$refs.SnackbarQV.print(
          "error",
          "Errore di comunicazione col server, non è stato possibile caricare i dati."
        );
      }
    },
    registrazioneElementi() {
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "registrazioneelementi",
          token: localStorage.user_token,
          elementi: this.items_elementi.filter((e) => e.selezionato == true),
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            this.$emit("click_salva");
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile caricare i dati."
            );
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile caricare i dati."
          );
        });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style scoped>
</style>